import {Routes} from '@angular/router';
import {noAuthGuard} from './core/guards/no-auth.guard';
import {LoginComponent} from './pages/login/login.component';
import {BaseLayoutComponent} from './shared/layout/base-layout/base-layout.component';
import {HomeComponent} from './pages/home/home.component';
import {authGuard} from './core/guards/auth.guard';
import {ShopSellersBatchListComponent} from './pages/sellers/sellers-list/shop-sellers-batch-list.component';
import {ForgotPasswordComponent} from './pages/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './pages/reset-password/reset-password.component';
import {UserListComponent} from './pages/users/list/user-list.component';
import {UserManageComponent} from './pages/users/manage/user-manage.component';
import {ShopSellersBatchDetailComponent} from './pages/sellers/batch-detail/shop-sellers-batch-detail.component';
import {ShopSellerListComponent} from './pages/shop-sellers/shop-seller-list/shop-seller-list.component';
import {ShopSellerViewComponent} from './pages/shop-sellers/shop-seller-view/shop-seller-view.component';
import {AuditEventListComponent} from './pages/audit/audit-event-list/audit-event-list.component';
import {AuditEventViewComponent} from './pages/audit/audit-event-view/audit-event-view.component';
import {
  InventoryFranchiseSearchComponent
} from './pages/inventory/inventory-franchise-search/inventory-franchise-search.component';
import {AdminProductSearchComponent} from './pages/catalog/admin-product-search/admin-product-search.component';
import {AdminProductViewComponent} from './pages/catalog/admin-product-view/admin-product-view.component';
import {ApplicationSettingsComponent} from './pages/system/application-settings/application-settings.component';
import {
  ROLE_APPLICATION_SETTINGS_READ,
  ROLE_AUDIT_MINIMAL_READ,
  ROLE_AUDIT_READ,
  ROLE_LABELING_READ,
  ROLE_USER_GROUPS_READ,
  ROLE_USER_GROUPS_WRITE,
  ROLE_VTEX_CATALOG_MINIMAL_READ,
  ROLE_VTEX_CATALOG_READ,
  ROLE_VTEX_ORDERS_READ,
  ROLE_VTEX_SHOP_SELLERS_MIN_READ,
  ROLE_VTEX_SHOP_SELLERS_READ,
  ROLE_VTEX_USER_READ,
  ROLE_VTEX_USER_WRITE,
} from './core/models/user/user-info.model';
import {OrdersListComponent} from './pages/orders/orders-list/orders-list.component';
import {TagListComponent} from './pages/labeling/tag-list/tag-list.component';
import {RolesListComponent} from './pages/roles/roles-list/roles-list.component';
import {UserGroupListComponent} from './pages/user-groups/user-group-list/user-group-list.component';
import {UserGroupManageComponent} from './pages/user-groups/user-group-manage/user-group-manage.component';
import {TagProductComponent} from './pages/labeling/tag-product/tag-product.component';
import {ShopSellerEditViewComponent} from './pages/shop-sellers/shop-seller-edit-view/shop-seller-edit-view.component';
import {OrderComponent} from './pages/orders/order/order.component';
import {TagEditComponent} from './pages/labeling/tag-edit/tag-edit.component';
import {TagCampaignListComponent} from './pages/labeling/campaign-list/tag-campaign-list.component';
import {TagCampaignEditComponent} from './pages/labeling/campaign-edit/tag-campaign-edit.component';
import {
  PromotionCampaignListComponent
} from './pages/labeling/promotional-campaign-list/promotional-campaign-list.component';
import {
  PromotionalCampaignEditComponent
} from './pages/labeling/promotional-campaign-edit/promotional-campaign-edit.component';
import {CampaignSetupComponent} from './pages/tagging/campaign-setup/campaign-setup.component';
import {CampaignListComponent} from './pages/tagging/campaign-list/campaign-list.component';
import { ProductListingComponent } from './pages/tagging/product-listing/product-listing.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: BaseLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
        data: {
          title: 'Página inicial',
        },
      },
      {
        path: 'orders',
        data: {
          requiredRoles: [ROLE_VTEX_ORDERS_READ],
        },
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            component: OrdersListComponent,
            data: {
              title: 'Listagem de pedidos',
            },
          },
          {
            path: 'order/:orderId',
            component: OrderComponent,
            data: {
              title: 'Exibição do pedido',
            },
          },
        ],
      },
      {
        path: 'catalog',
        children: [
          {
            path: 'products',
            component: AdminProductSearchComponent,
            data: {
              requiredRoles: [ROLE_VTEX_CATALOG_READ, ROLE_VTEX_CATALOG_MINIMAL_READ],
            },
          },
          {
            path: 'inventory',
            component: InventoryFranchiseSearchComponent,
            data: {
              requiredRoles: [ROLE_VTEX_CATALOG_READ],
            },
          },
          {
            path: 'product/:productId',
            component: AdminProductViewComponent,
            data: {
              requiredRoles: [ROLE_VTEX_CATALOG_READ, ROLE_VTEX_CATALOG_MINIMAL_READ],
            },
          },
        ],
      },
      {
        path: 'tagging',
        data: {
          requiredRoles: [ROLE_LABELING_READ],
        },
        children: [
          {
            path: 'offers',
            component: ProductListingComponent
          },
          {
            path: 'offers/:skuId',
            component: TagProductComponent
          },
          {
            path: 'promotional-campaigns',
            component: CampaignListComponent
          },
          {
            path: 'campaign/:campaignId',
            component: CampaignSetupComponent
          }
        ]
      },
      {
        path: 'shop-sellers',
        children: [
          {
            path: '',
            component: ShopSellerListComponent,
            data: {
              title: 'Vendedores',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_READ],
            },
          },
          {
            path: 'seller/:sellerId',
            component: ShopSellerViewComponent,
            data: {
              title: 'Visualização de vendedor',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_READ],
            },
          },
        ],
      },
      {
        path: 'shop-sellers-minimal',
        children: [
          {
            path: '',
            component: ShopSellerListComponent,
            data: {
              title: 'Vendedores',
              version: 'minimal',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_MIN_READ],
            },
          },
          {
            path: 'seller/:sellerId',
            component: ShopSellerEditViewComponent,
            data: {
              title: 'Visualização de vendedor',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_MIN_READ],
            },
          },
        ],
      },
      {
        path: 'batch-shop-sellers',
        children: [
          {
            path: '',
            component: ShopSellersBatchListComponent,
            data: {
              title: 'Lotes de vendedores',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_READ],
            },
          },
          {
            path: 'batch/:id',
            component: ShopSellersBatchDetailComponent,
            data: {
              title: 'Detalhes do lote de vendedores',
              requiredRoles: [ROLE_VTEX_SHOP_SELLERS_READ],
            },
          },
        ],
      },
      {
        path: 'audit',
        children: [
          {
            path: '',
            redirectTo: 'events',
            pathMatch: 'full',
          },
          {
            path: 'events',
            component: AuditEventListComponent,
            data: {
              title: 'Listagem de eventos de auditoria',
              requiredRoles: [ROLE_AUDIT_READ, ROLE_AUDIT_MINIMAL_READ],
            },
          },
          {
            path: 'event/:eventId',
            component: AuditEventViewComponent,
            data: {
              title: 'Evento de auditoria',
              requiredRoles: [ROLE_AUDIT_READ],
            },
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            component: UserListComponent,
            data: {
              title: 'Listagem de grupos de usuários',
              requiredRoles: [ROLE_VTEX_USER_READ],
            },
          },
          {
            path: 'create',
            component: UserManageComponent,
            data: {
              title: 'Criar novo usuário',
              requiredRoles: [ROLE_VTEX_USER_WRITE],
            },
          },
          {
            path: 'edit/:userId',
            component: UserManageComponent,
            data: {
              title: 'Atualizar usuário',
              requiredRoles: [ROLE_VTEX_USER_READ],
            },
          },
          {
            path: 'groups',
            children: [
              {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full',
              },
              {
                path: 'list',
                component: UserGroupListComponent,
                data: {
                  title: 'Listagem de grupos de usuários',
                  requiredRoles: [ROLE_USER_GROUPS_READ],
                },
              },
              {
                path: 'create',
                component: UserGroupManageComponent,
                data: {
                  title: 'Criar novo grupo de usuário',
                  requiredRoles: [ROLE_USER_GROUPS_WRITE],
                },
              },
              {
                path: 'edit/:groupId',
                component: UserGroupManageComponent,
                data: {
                  title: 'Atualizar grupo de usuário',
                  requiredRoles: [ROLE_USER_GROUPS_READ],
                },
              },
            ],
          },
          {
            path: 'roles',
            component: RolesListComponent,
            data: {
              title: 'Listagem de funções',
              requiredRoles: [ROLE_USER_GROUPS_READ],
            },
          },
        ],
      },
      {
        path: 'system',
        children: [
          {
            path: 'application-settings',
            component: ApplicationSettingsComponent,
            data: {
              title: 'Configurações do sistema',
              requiredRoles: [ROLE_APPLICATION_SETTINGS_READ],
            },
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [noAuthGuard],
    data: {
      title: 'Login',
    },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [noAuthGuard],
    data: {
      title: 'Esqueceu a senha?',
    },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [noAuthGuard],
    data: {
      title: 'Resetar senha',
    },
  },
];
